export const enum OTP_MEANS {
  email = "Email",
  app = "App",
  none = "None",
  passkey = "Passkey"
}

export enum UserProjectsEnum {
  LEARNING = "LEARNING",
  EXAM = "EXAM",
  PRO = "PRO",
  WORK_WITH_US = "WORK_WITH_US",
  HR = "HR"
}

export enum UserRoleEnum {
  SUPER_ADMIN = "superAdmin",
  ADMIN = "admin",
  PRO_ADMIN = "proAdmin",
  PRO_ADMIN_QC = "proAdminQC",
  PRO_INTERVIEW_RATER = "ProRater",
  PRO_SCREENER = "proScreener",
  STUDENT = "student",
  LEARNER = "learnerStudent",
  LEARNING_ADMIN = "learnerAdmin",
  EXAM_ADMIN = "examAdmin",
  USER = "User",
  SCHOOL_ADMIN = "schoolAdmin",
  FACILITATOR_ADMIN = "facilitatorAdmin",
  WORK_WITH_US = "workwithusApplicant",
  HR_ADMIN = "hrAdmin",
  FINANCE_ADMIN = "financeAdmin",
  PRO_INTERVIEWER = "proInterviewer",
  PRO_MODERATOR = "proModerator",
}

export const adminUserRoles: UserRoleEnum[] = [
  UserRoleEnum.SUPER_ADMIN,
  UserRoleEnum.ADMIN,
  UserRoleEnum.PRO_ADMIN,
  UserRoleEnum.PRO_ADMIN_QC,
  UserRoleEnum.LEARNING_ADMIN,
  UserRoleEnum.HR_ADMIN,
  UserRoleEnum.SCHOOL_ADMIN,
  UserRoleEnum.EXAM_ADMIN,
  UserRoleEnum.FINANCE_ADMIN,
  UserRoleEnum.PRO_SCREENER,
];

export interface AuthStateModel {
  loading: boolean,
  preAuthConfig: PreAuthResponse | null,
  auth: AuthResponse,
  error: string | null,
  referralJobSlug: string | null,
  isOtpValidated: boolean;
  secret: string | null;
  qrText: string | null;
  passkeys: UserPasskey[];
  passkeySetupInProgress: boolean;
  passkeyResponse: PasskeyRegistrationOptions | null
  passkeyAuthResponse: PublicKeyCredentialRequestOptionsJSON | null
}

export interface AuthResponse {
  id: string | null;
  email: string | null;
  user: UserAuthResponse | null; // Store user details (type can be replaced with a specific user interface)
  token: string | null; // Store token if applicable
  refreshToken: string | null;
  isGeneratedPassword: boolean;
  skipValidation: boolean;
  mfaMethod: "None" | "Email" | "App" | "Passkey";
  requiresMfa: boolean;
  loading: boolean; // To show loaders during API calls
}

export interface PreAuthResponse {
  id: string;
  email: string;
  profiles: ProfileModel[];
}

// export interface PasskeyRegistrationOptions {
//   challenge: string;
//   rp: {
//     name: string;
//     id: string;
//   };
//   user: {
//     id: string;
//     name: string;
//     displayName: string;
//   };
//   pubKeyCredParams: Array<{
//     alg: number;
//     type: string;
//   }>;
//   timeout: number;
//   attestation: AttestationConveyancePreference;
//   excludeCredentials: any[];
//   authenticatorSelection: {
//     residentKey: string;
//     userVerification: string;
//     authenticatorAttachment: string;
//     requireResidentKey: boolean;
//   };
//   extensions: {
//     credProps: boolean;
//   };
//   hints: any[];
// }

export interface LoginResponse {
  id: string;
  email: string;
  isOtpEnabled: boolean;
  // otpMeans: string;
  otpMeans: "None" | "Email" | "App";
  isStaff: boolean;
  authToken: string;
  user: UserAuthResponse;
  profiles: ProfileModel[];
  token: string;
}
export interface UserAuthResponse {
  id: string;
  email: string;
  profiles: ProfileModel[];
  isOtpEnabled: boolean;
  otpMeans: OTP_MEANS;
}

export interface ProfileModel {
  id: string;
  role: UserRoleEnum;
  project: string;
}

export interface UserModel {
  office: string;
  examTypes: string[]; // Assuming this is an array of unknown types
  email: string;
  phone: string;
  avatar?: string;
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string; // ISO 8601 date format
  legalStatus: string;
  countryOfBirth: string;
  motherTongue: string;
  streetAdress: string;
  streetAdressOpt: string;
  unitNumber: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
  emergencyName: string;
  emergencyRelationship: string;
  emergencyPhone: string;
  emergencyEmail: string;
  univer: string; // University name
  degreeProgrammArea: string;
  degreeAchived: string;
  degreeProgramm: string;
  educationCountry: string;
  practiceLang: string;
  yearsOfPractice: string;
  educationLang: string;
  role: string;
  authId: string;
  cnoNumber: string;
  accountStatus: string;
  accountType: string;
  privileges: any[]; // Assuming this is an array of unknown types
  resetToken: string;
  updatedAt: string; // ISO 8601 date format
  isStaff: boolean;
  programNos: any[]; // Assuming this is an array of unknown types
  id: string;
}

export interface Profile {
  id: string;
  accountStatus: string;
  accountType: string;
  cnoNumber: string;
  isStaff: boolean;
  role: string;
  name: string;
  avatar: string;
}


export enum USER_ROLES {
  SUPER_ADMIN = 'superAdmin',
  EXAM_ADMIN = 'admin',
  PRO_ADMIN = 'proAdmin',
  STUDENT = 'student',
  LEARNER = 'learnerStudent',
  LEARNING_ADMIN = 'learnerAdmin',
  LEARNING_FACILITATOR_ADMIN = 'facilitatorAdmin',
  PRO_INTERVIEWER = 'proInterviewer',
  PRO_MODERATOR = 'proModerator',
  PRO_SCREENER = "proScreener",
  WORK_WITH_US_ADMIN = 'workWithUsAdmin',
}


// export interface ExamFilterOptions {
//     type?: "allNotRegistered" | "allguests" | "allapplications";

//     cnoNumbers?: string[];
//     emails?: string[];

//     examIds?: string[];
//     examApplictionStatus?: string;
// }

// export interface LearningFilterOptions {
//     type?: "allNotRegistered" | "allguests" | "allapplications";

//     emails?: string[];
//     learnerIds?: string[];

//     learningIds?: string[];
//     learningApplictionStatus?: string;
// }

export type Maybe<T> = T | null | undefined;


export interface AuthenticationOptions {
  examType: string,
  userId: string,
  authId: string
}

export interface AuthTokenOptions {
  examType?: string,
  jobSlug?: string,
  code: string;
  reload?: string;
  email?: string; // Optional email for conditional redirects
}

// Passkey related interfaces
export interface PasskeyCredential {
  id: string;
  rawId: string;
  response: {
    clientDataJSON: string;
    attestationObject: string;
  };
  type: 'public-key';
}


export interface PublicKeyCredentialRequestOptionsJSON {
  challenge: string;
  timeout?: number;
  rpId?: string;
  allowCredentials?: Array<{
    type: string;
    id: string;
    transports?: string[];
  }>;
  userVerification?: string;
  extensions?: any;
}

export interface PasskeyRegistrationOptions {
  rp: {
    name: string;
    id: string;
  };
  user: {
    id: string;
    name: string;
    displayName: string;
  };
  challenge: string;
  pubKeyCredParams: PublicKeyCredentialParameters[];
  timeout: number;
  attestation: AttestationConveyancePreference;
  authenticatorSelection: {
    residentKey?: ResidentKeyRequirement;
    userVerification?: UserVerificationRequirement;
    authenticatorAttachment: AuthenticatorAttachment;
    requireResidentKey: boolean;
  };
  excludeCredentials: any[];
  extensions: {
    credProps: boolean;
  };
}

export interface PasskeyAuthenticationOptions {
  challenge: string;
  timeout: number;
  rpId: string;
  allowCredentials: Array<{
    type: string;
    id: string;
  }>;
}

export interface UserPasskey {
  id: string;
  deviceName: string;
  credentialId: string;
  createdAt: string;
  lastUsedAt: string | null;
}
